import React from 'react';
import { Link } from 'react-router-dom';
import { getProfilePic } from '../../helpers/images';
import styles from './Seller.module.scss';

export default function Seller({ seller }: any) {
  return (
    <Link className={styles.container} to={`/profile/${seller.id}`}>
      <img src={getProfilePic(seller?.photo)} />

      <div className={styles.info}>
        <h2>Datos del vendedor</h2>
        <p>{seller.name}</p>
        <p>
          {seller.isVerified ? (
            <>
              <i className="fonticons fonticons-checked" />
              <span>Usuario Verificado</span>
            </>
          ) : (
            <>
              <span>No verificado</span>
            </>
          )}
        </p>
        <p>{seller.sellerType}</p>
      </div>
    </Link>
  );
}
